export default __webpack_public_path__ + "static/media/default.66b61532.png";